import { useEffect, useState } from "react";
import { ArrowUpRight, Menu, X } from "lucide-react";

const LINKS = [
  { label: "Manifesto", href: "#manifesto" },
  { label: "Services", href: "#services" },
  { label: "Results", href: "#results" },
  { label: "Voices", href: "#voices" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color] duration-500 border-b ${
        scrolled
          ? "bg-[#09090A]/60 backdrop-blur-2xl border-white/10"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="header-logo" className="flex items-center gap-3 group">
          <span className="logo-3d block">
            <img src="/logo-icon.png" alt="AdStellar Media" className="h-11 w-11" />
          </span>
          <span className="flex items-baseline gap-1.5">
            <span className="font-display text-xl font-bold tracking-tight">AdStellar</span>
            <span className="font-accent text-[9px] tracking-[0.3em] uppercase text-[#8B5CF6]">Media</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10" data-testid="header-nav">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-accent text-xs tracking-[0.2em] uppercase text-[#A0A0AB] hover:text-[#F8F8F8] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <a
            href="mailto:biz@adstellarmedia.com?subject=Let's%20Talk%20Strategy"
            data-testid="header-cta-button"
            className="hidden md:inline-flex items-center gap-2 border border-white/20 px-6 py-3 font-accent text-xs tracking-[0.2em] uppercase hover:bg-[#8B5CF6] hover:border-[#8B5CF6] transition-[background-color,border-color] duration-300 group"
          >
            Let's Talk
            <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="md:hidden bg-[#09090A]/95 backdrop-blur-2xl border-t border-white/10 px-6 py-8 flex flex-col gap-6" data-testid="mobile-nav">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-display text-3xl italic text-[#F8F8F8]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="mailto:biz@adstellarmedia.com?subject=Let's%20Talk%20Strategy"
            data-testid="mobile-cta-button"
            className="mt-4 inline-flex items-center justify-center gap-2 bg-[#8B5CF6] px-6 py-4 font-accent text-xs tracking-[0.2em] uppercase"
          >
            Let's Talk Strategy <ArrowUpRight className="w-4 h-4" />
          </a>
        </nav>
      )}
    </header>
  );
};
